package com.patronat.top.features.venues.domain.usecase.command

import com.patronat.top.dto.venues.VenueStatus

data class UpdateVenueStatusCommand(
    val venueId: String,
    val status: VenueStatus
)
